import React, { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";

export default function QRCodePage() {
  const { user } = useAuth();
  const [publicUrl, setPublicUrl] = useState("");

  useEffect(() => {
    if (user?.slug) {
      api.get(`/public/qr/${user.slug}/data`).then((r) => setPublicUrl(r.data.url)).catch(() => {});
    }
  }, [user?.slug]);

  const download = () => {
    const canvas = document.querySelector("#neivai-qr canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = `${user?.slug || "neiv"}-qr.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const printQR = () => {
    const w = window.open("", "_blank");
    if (!w) return;
    const canvas = document.querySelector("#neivai-qr canvas");
    const src = canvas?.toDataURL();
    w.document.write(`<html><head><title>NEIV · ${user?.business_name}</title>
      <style>
        body{font-family:sans-serif;text-align:center;padding:60px;background:#FAFAFA;color:#1A1C1E}
        h1{font-size:32px;margin-bottom:8px}
        p{color:#5C5F62}
        img{margin:40px auto;border:1px solid #E5E5E5;padding:24px;border-radius:16px;background:#fff}
      </style></head><body>
      <h1>${user?.business_name}</h1>
      <p>Scan to sign in</p>
      <img src="${src}" width="360" />
      <p style="margin-top:24px;font-size:14px">Powered by NEIV</p>
      </body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 400);
  };

  return (
    <div className="max-w-3xl mx-auto space-y-8" data-testid="qr-page">
      <div>
        <span className="overline">Retail</span>
        <h1 className="mt-3 text-4xl md:text-5xl font-display font-semibold tracking-tight">Your store QR</h1>
        <p className="mt-2 text-[#5C5F62]">Print &amp; place this on your showroom shelves. Every scan opens the sign-in page for your team.</p>
      </div>

      <div className="neivai-card p-10 md:p-14 flex flex-col md:flex-row items-center gap-10">
        <div id="neivai-qr" className="p-6 bg-white border border-[#E5E5E5] rounded-2xl">
          {user?.slug && (
            <QRCodeCanvas value={publicUrl || " "} size={240} bgColor="#FFFFFF" fgColor="#1A1C1E" level="M" includeMargin={false} />
          )}
        </div>
        <div className="flex-1 flex flex-wrap gap-3">
          <button data-testid="qr-download-btn" onClick={download} className="neivai-btn-primary inline-flex items-center gap-2">
            <Download className="h-4 w-4" /> Download PNG
          </button>
          <button data-testid="qr-print-btn" onClick={printQR} className="neivai-btn-secondary inline-flex items-center gap-2">
            <Printer className="h-4 w-4" /> Print poster
          </button>
        </div>
      </div>
    </div>
  );
}
